theme.Contact = (function() {
  function Contact(container) {
    // The previous implementation used a custom function and a hidden input to collect checkbox values.
    // This new, streamlined code removes that logic to allow native browser functionality, which
    // correctly handles multiple checkbox selections. We also remove the 'honeypot' logic to prevent
    // any side effects on form submission.
    
    // Select the form element
    var form = container.querySelector('form');

    // Handle form submission
    form.addEventListener('submit', function(ev) {
      // The 'Extra' field is a spam-prevention measure (a honeypot).
      // If it's filled out, we prevent the form from submitting.
      if (document.getElementById('contactFormNumber').value.length > 0) {
        ev.preventDefault();
      }
    });

    // We no longer need the honeypot button replacement, as the form now submits naturally
    // when a user clicks on the submit button.
    var hny = document.getElementById('honeypot');
    if (hny) {
      var btn = hny.querySelector('.btn-replace');
      if (btn) {
        btn.remove();
        hny.innerHTML = '<input class="btn standard-width bottompad" type="submit" value="' + theme.language.contact_form_send + '" id="contactFormSubmit" />';
      }
    }
  }
  return Contact;
})();
